/**
 * Prefetch core routes in the background for instant navigation.
 * Called after authentication to preload commonly-used pages.
 */
export function prefetchCoreRoutes() {
  const prefetch = () => {
    // Bottom nav tabs (most frequently used)
    import('../components/Groups');
    import('../components/Profile');
    import('../components/Offers');
    
    // Other common pages
    import('../components/Balance');
    import('../components/ActivityDetail');
    import('../components/ActivityList');
  };

  // Use requestIdleCallback if available (prefetch when browser is idle)
  // Otherwise fall back to setTimeout
  if ('requestIdleCallback' in window) {
    requestIdleCallback(prefetch);
  } else {
    setTimeout(prefetch, 2000);
  }
}
